var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert",on:{"touchmove":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"mask",on:{"touchmove":function($event){$event.preventDefault();}}}),(_vm.type === '')?_c('div',{staticClass:"alert-box"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }